<div class="editor-wrap"
  [class.panning]="isPanning"
  [class.shaping]="['rect','circle','ellipse','triangle','line','polygon'].includes(tool)">
  <canvas #canvas></canvas>

  <!-- Floating clipboard toolbar -->
  <div class="floating-hint" *ngIf="floatingClip" (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">

    <!-- Circle: single Radius input -->
    <ng-container *ngIf="floatingClip.shapeType === 'circle'">
      <label class="float-dim-label">R</label>
      <input class="float-dim-input" type="number" min="1" [value]="floatR"
             (change)="resizeFloatingClip('r', +$any($event.target).value)">
    </ng-container>

    <!-- Ellipse: Rx + Ry -->
    <ng-container *ngIf="floatingClip.shapeType === 'ellipse'">
      <label class="float-dim-label">Rx</label>
      <input class="float-dim-input" type="number" min="1" [value]="floatRx"
             (change)="resizeFloatingClip('rx', +$any($event.target).value)">
      <label class="float-dim-label">Ry</label>
      <input class="float-dim-input" type="number" min="1" [value]="floatRy"
             (change)="resizeFloatingClip('ry', +$any($event.target).value)">
    </ng-container>

    <!-- Rect / Triangle / Line / paste (no shapeType) / everything else: W + H -->
    <ng-container *ngIf="floatingClip.shapeType !== 'circle' && floatingClip.shapeType !== 'ellipse'">
      <label class="float-dim-label">W</label>
      <input class="float-dim-input" type="number" min="1" [value]="floatW"
             (change)="resizeFloatingClip('w', +$any($event.target).value)">
      <label class="float-dim-label">H</label>
      <input class="float-dim-input" type="number" min="1" [value]="floatH"
             (change)="resizeFloatingClip('h', +$any($event.target).value)">
    </ng-container>

    <span class="sel-divider"></span>
    <button class="sel-btn" (click)="stampFloatingClip()">✓ Place <kbd>Enter</kbd></button>
    <button class="sel-btn sel-close" (click)="floatingClip = null; draw()">✕</button>
  </div>

  <!-- Selection toolbar -->
  <div class="sel-toolbar" *ngIf="selection && !floatingClip" (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">
    <button class="sel-btn" (click)="copySelection()" title="Copy selection to floating clipboard">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
      Copy <kbd>Ctrl+C</kbd>
    </button>
    <button class="sel-btn" (click)="cutSelection()" title="Cut selection">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="6" cy="20" r="2"/><circle cx="6" cy="4" r="2"/><line x1="6" y1="6" x2="6" y2="18"/><line x1="6" y1="12" x2="20" y2="4"/><line x1="6" y1="12" x2="20" y2="20"/></svg>
      Cut <kbd>Ctrl+X</kbd>
    </button>
    <button class="sel-btn" (click)="copySelection()" title="Paste clipboard at this selection (copy first, then paste)">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>
      Paste <kbd>Ctrl+V</kbd>
    </button>
    <span class="sel-divider"></span>
    <button class="sel-btn" (click)="fillSelectionArea()" title="Fill selection with active color">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m19 11-8-8-8.5 8.5a5.5 5.5 0 0 0 7.78 7.78L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/></svg>
      Fill
    </button>
    <button class="sel-btn" (click)="clearSelectionArea()" title="Clear selection to black [Delete]">
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
      Clear <kbd>Del</kbd>
    </button>
    <span class="sel-divider"></span>
    <button class="sel-btn" (click)="flipSelectionH()" title="Flip horizontal">↔ FlipH</button>
    <button class="sel-btn" (click)="flipSelectionV()" title="Flip vertical">↕ FlipV</button>
    <button class="sel-btn" (click)="rotateSelection90(true)"  title="Rotate 90° clockwise [R]">↻ CW</button>
    <button class="sel-btn" (click)="rotateSelection90(false)" title="Rotate 90° counter-clockwise [Shift+R]">↺ CCW</button>
    <span class="sel-divider"></span>
    <button class="sel-btn sel-close" (click)="deselect()" title="Deselect [Esc]">✕</button>
  </div>

  <!-- Polygon hint -->
  <div class="poly-hint" *ngIf="tool === 'polygon' && polyPoints.length > 0">
    {{ polyPoints.length }} points · double-click to close
    <button class="sel-btn sel-close" (click)="polyPoints = []; draw()">✕ Cancel</button>
  </div>

  <!-- Resize mode hint (shows during handle drag) -->
  <div class="resize-hint" *ngIf="isSelTransforming && selResizeHandle">
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
    Drag to stretch · <kbd>Shift</kbd> = expand boundary only
  </div>

  <!-- Shape dimensions panel -->
  <div class="shape-dims" (mousedown)="$event.stopPropagation()" *ngIf="shapeDimsVisible && ['rect','circle','ellipse','triangle','line'].includes(tool)">
    <span class="shape-dims-label">{{ tool | titlecase }}</span>
    <ng-container *ngIf="tool === 'line'">
      <label>Length</label><span>{{ shapePreviewDims.length ?? '-' }}px</span>
    </ng-container>
    <ng-container *ngIf="tool === 'rect'">
      <label>W</label><span>{{ shapePreviewDims.w ?? '-' }}</span>
      <label>H</label><span>{{ shapePreviewDims.h ?? '-' }}</span>
    </ng-container>
    <ng-container *ngIf="tool === 'circle'">
      <label>Radius</label><span>{{ shapePreviewDims.r ?? '-' }}</span>
    </ng-container>
    <ng-container *ngIf="tool === 'ellipse'">
      <label>Rx</label><span>{{ shapePreviewDims.rx ?? '-' }}</span>
      <label>Ry</label><span>{{ shapePreviewDims.ry ?? '-' }}</span>
    </ng-container>
    <ng-container *ngIf="tool === 'triangle'">
      <label>Base</label><span>{{ shapePreviewDims.base ?? '-' }}</span>
      <label>H</label><span>{{ shapePreviewDims.height ?? '-' }}</span>
    </ng-container>
  </div>

  <!-- Image import panel -->
  <div class="import-overlay" *ngIf="showImportModal">
    <div class="import-panel">
      <div class="import-panel-header">
        <span>Position Image - drag on canvas or use inputs</span>
        <button class="import-close" (click)="cancelImport()">✕</button>
      </div>
      <div class="import-panel-body">
        <div class="import-row">
          <label>X</label>
          <input type="number" [(ngModel)]="importX" (ngModelChange)="updateImportConfig()" min="-200" max="1000">
          <label>Y</label>
          <input type="number" [(ngModel)]="importY" (ngModelChange)="updateImportConfig()" min="-200" max="1000">
        </div>
        <div class="import-row">
          <label>W</label>
          <input type="number" [(ngModel)]="importScaleW" (ngModelChange)="updateImportConfig()" min="1" max="1000">
          <label>H</label>
          <input type="number" [(ngModel)]="importScaleH" (ngModelChange)="updateImportConfig()" min="1" max="1000">
        </div>
        <div class="import-row">
          <label>Opacity</label>
          <input type="range" [(ngModel)]="importOpacity" (ngModelChange)="updateImportConfig()" min="10" max="100" style="flex:1">
          <span>{{ importOpacity }}%</span>
        </div>
        <div class="import-actions">
          <button class="pxl-btn pxl-btn-secondary pxl-btn-sm" (click)="cancelImport()">Cancel</button>
          <button class="pxl-btn pxl-btn-primary" (click)="commitImport()">✓ Place on Canvas</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Hint bar (expand/collapse persisted in userConfig / IDB) -->
  <div class="canvas-controls-hint" [class.canvas-controls-hint--expanded]="canvasHintsExpanded">
    <button type="button" class="canvas-hint-toggle"
      (click)="toggleCanvasHints(); $event.stopPropagation()"
      [attr.aria-expanded]="canvasHintsExpanded"
      [attr.aria-label]="canvasHintsExpanded ? 'Collapse keyboard shortcuts' : 'Expand keyboard shortcuts'"
      title="Keyboard shortcuts">
      @if (canvasHintsExpanded) {
        <svg lucideChevronRight [size]="18" [strokeWidth]="2" class="canvas-hint-toggle-icon"></svg>
      } @else {
        <svg lucideChevronLeft [size]="18" [strokeWidth]="2" class="canvas-hint-toggle-icon"></svg>
      }
    </button>
    @if (canvasHintsExpanded) {
      <div class="canvas-hint-chips">
        <span class="pxl-kbd">Scroll</span>Zoom
        <span class="pxl-kbd">F</span>Fit
        <span class="pxl-kbd">S</span>Sel
        <span class="pxl-kbd">A</span>Add Frame
        <span class="pxl-kbd">Del</span>Clear
        <span class="pxl-kbd">R</span>Rotate
        <span class="pxl-kbd">[ ]</span>Brush
        <span class="pxl-kbd">Ctrl+Z</span>Undo
      </div>
    }
  </div>

  <!-- Collab syncing overlay - shown when receiving bulk frame data -->
  <div class="collab-syncing-overlay" *ngIf="collabSyncing">
    <div class="syncing-spinner"></div>
    <div class="syncing-text">Syncing canvas…</div>
  </div>
</div>
